const state: PartnerStateObj = {
  active: {},
  list: []
};

export default { ...state };
